module.exports = __webpack_public_path__ + "img/icon_left_2.1a490042.png";